import { formatDate } from "../../../functions/dateTime/formatDate";
import {
  getVisitStatus,
  getVehicleReadingStatus,
} from "../helpers/getComplaintStatus";
import { checkValue } from "../../../functions/checkValue";
import { formatTime } from "../../../functions/dateTime/getTimeString";

export const formatComplaintExcelData = (complaintsData) => {
  return complaintsData.map((c) => ({
    "Site ID": String(c.station.id),
    "Site Name": c.station.name,
    "Field Technician": c.fieldTechnician?.fullName,
    Supervisor: c.supervisor.fullName,
    "Created At": formatDate(c.createdAt),
    "Updated At": formatDate(c.updatedAt),
    Category: c.category.name,
    Description: c.description,
    "Visit Status": c.visitIdList?.length > 0 ? "Visited" : "Not Visited",
    "Last Visit Date": formatDate(c.last_visit_date),
  }));
};

export const formatVisitExcelData = (visitData) => {
  return visitData.map((v) => ({
    "Site ID": String(v.station.id),
    "Site Name": v.station.name,
    "Machine ID": String(checkValue(v.station?.machine?.id)),
    "Field Technician": v.fieldTechnician?.fullName,
    Supervisor: v.supervisor.fullName,
    "Visit Date": formatDate(v.visitedAt),
    "Work Done": v.workDone,
    Category: v.category?.name,
    Status: getVisitStatus(v.status).status,
  }));
};

export const formatCylinderChangeExcelData = (data) => {
  return data.map((d) => ({
    "Staion ID": String(d.stationId),
    "Station Name": d.stationName,
    "Field Technician": d.fieldTechnicianName,
    Supervisor: d.supervisorName,
    "Complaint ID": String(checkValue(d.complaintId)),
    "Complaint Date": formatDate(d.complaintDate),
    "Date of complaint attended": formatDate(d.dateOfComplainAttended),
    "Working Cyl No.": d.workingCylinder,
    "Last Working Cyl No.": d.lastWorkingCylinder,
    "Standby Cyl No.": d.standbyCylinder,
    "Last Standby Cyl No.": d.lastStandbyCylinder,
    "Dose Set": String(d.doseSet),
    "Daily Supply Hour": d.dailySupplyHour
      ? String(d.dailySupplyHour / 100)
      : "-",
  }));
};

export const formatVehicleReadingslData = (vehiclesData) => {
  return vehiclesData.map((v) => ({
    "Reading Date": formatDate(v.logDate),
    "Vehicle Number": v.vehicleNumber,
    "Created By": v.createdBy?.fullName,
    "Intial Reading": v.morningReading,
    "Final Reading": v.eveningReading,
    "Intial Reading Time": formatTime(v.morningReadingAt),
    "Final Reading Time": formatTime(v.eveningReadingAt),
    Distance: v.distanceKm,
    Status: getVehicleReadingStatus(v.status).status,
  }));
};
